// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router/index';
import 'amfe-flexible';
import './assests/css/index.css';
import './directive/index';
import {handleAPI} from '@js/fetch/index';
import store from './store/index';

// 全局自己编写的公共组件
import comoponents from './components/common.js';
import sdk from '@js/native/index';
import {statistics} from '@js/config/index';
import {SenderEventTrack} from '@threegene/track';
import {UseNativeApi} from '@js/util/index';
// 用户调研工具
import SetUrt from '@js/util/urt/index';

import {version} from '../package.json';

Vue.use(comoponents);
Vue.config.productionTip = false;
Vue.prototype.statistics = statistics;
Vue.prototype.handleAPI = handleAPI;
SetUrt(Vue, router);

window.sdk = sdk;
const isOnline = process.env['HOST'] !== 'prod';
if (isOnline) {
  require('./components/Vconsole/index');
  new VConsole();
}
/* eslint-disable no-new */
Vue.use(SenderEventTrack, {
  _pro: 'xdm', // 项目组名称 必传
  _v: version, // 相关应用版本（PS：统一为纯数字即可，不要用v1.0） 必传
  _isPro: !isOnline, // true是生产环境 传false、不传、乱传都是测试环境 非必传
  threshold: 0.5,
  isCapture: true,
  isAutoTrack: true,
  showLog: isOnline,
  get _childId() {
    return store.state.child.childId;
  }
});

Vue.use(UseNativeApi);

new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js